import { useSelector } from 'react-redux'

import { usePagination } from '@/atoms'
import { selectWorkingDayStartSec } from '@/features/domain/territory'
import { selectGpsTrackingProvider } from '@/features/domain/user'
import { useFormTransaction } from '@/hooks'

import { Exception } from './Exception'
import { GeneralSettings } from './GeneralSettings'
import { useTexts } from './hooks/useTexts'
import { createEmptyUnifiedVehicle } from './utils/createEmptyUnifiedVehicle'

interface Props {
  unifiedVehicle?: uui.domain.client.UnifiedVehicle
}

export function SingleEdit(props: Props) {
  const { unifiedVehicle } = props
  const { page } = usePagination('vehicleTab')
  const texts = useTexts()

  const workingDayStartSec = useSelector(selectWorkingDayStartSec)
  const trackingProvider = useSelector(selectGpsTrackingProvider)

  const transactionState = useFormTransaction()
  const transactionOpen = transactionState === 'ready'

  if (!unifiedVehicle) {
    const emptyUnifiedVehicle = createEmptyUnifiedVehicle(
      texts.newVehicle,
      {
        startSec: workingDayStartSec,
        endSec: workingDayStartSec + 24 * 60 * 60,
      },
      trackingProvider,
    )
    return (
      <GeneralSettings
        trackingProvider={trackingProvider}
        transactionOpen={transactionOpen}
        unifiedVehicle={emptyUnifiedVehicle}
        creating
      />
    )
  }

  switch (page) {
    case 0:
      return (
        <GeneralSettings
          trackingProvider={trackingProvider}
          transactionOpen={transactionOpen}
          unifiedVehicle={unifiedVehicle}
        />
      )

    case 1:
      return <Exception unifiedVehicle={unifiedVehicle} transactionOpen={transactionOpen} />

    default:
      return null
  }
}
